// Product Slider - Thumbnails

document.addEventListener("DOMContentLoaded", function () {

  var main = new Splide( '#main-carousel', {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: false,
    autoHeight: true,
    breakpoints: {
      768: {

      },
    }
  });

  var thumbnails = new Splide( '#thumbnail-carousel', {
    gap: '10px',
    perPage: 3,
    pagination: false,
    isNavigation: true,
    arrows: false,
    direction: 'ttb',
    height: 680,
    fixedHeight: 140,
    cover: true,
    breakpoints: {
      768: {
        direction: 'ltr',
         gap: 10,
        perPage: 3,
      },
    }
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();
  
});
